import './style.scss';
import { icons } from 'constants/icons';
import { useState, useEffect, useCallback } from 'react';
import { IconColor, IconSize, SvgIcon } from 'views/mutual/svgIcon';
import { MenuItems } from '../hooks';
import { useLocation } from 'react-router-dom';

export const HamburgerMenu = (props: MenuItems) => {
  const location = useLocation();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const toggleModal = useCallback(() => {
    setIsModalOpen((prev) => !prev);
  }, []);

  useEffect(() => {
    setIsModalOpen(false);
  }, [location]);

  return (
    <>
      <div className="hamburgerMenu">
        <label className="hamburgerMenu_hamburger" onClick={toggleModal}>
          <SvgIcon icon={icons.hamburger} size={IconSize.icon_m} color={IconColor.primary} />
        </label>
      </div>
      {isModalOpen && (
        <div className="hamburgerMenu_overLay">
          <div
            className="hamburgerMenu_listWrapper"
            onClick={(e) => {
              if (e.target === e.currentTarget) {
                toggleModal();
              }
            }}
          >
            <div className="hamburgerMenu_list">
              <div className="hamburgerMenu_list_account">
                <div className="hamburgerMenu_list_account_label">口座番号</div>
                <div className="hamburgerMenu_list_account_value">{props.account.branch}</div>
              </div>
              <div className="hamburgerMenu_list_account">
                <div className="hamburgerMenu_list_account_label">最終ログイン日時</div>
                <div className="hamburgerMenu_list_account_value">{props.account.lastLoginDateTime}</div>
              </div>
              {props.items.concat([props.notice, props.faq, props.contact, props.logout].filter(item => item != null)).map((item) => (
                <div key={item.key} className="hamburgerMenu_list_item">
                  <span
                    className="hamburgerMenu_list_item_label"
                    onClick={() => {
                      item.onClick();
                      toggleModal();
                    }}
                  >
                    {item.name}
                  </span>
                  {item.childItems && (
                    <div className="hamburgerMenu_list_item_child">
                      {item.childItems.map((childItem) => (
                        <div
                          key={childItem.key}
                          className="hamburgerMenu_list_item_child_label"
                          onClick={() => {
                            childItem.onClick();
                            toggleModal();
                          }}
                        >
                          {childItem.name}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </>
  );
};
